module.exports = __webpack_public_path__ + "img/28.0b90ad36.jpg";